import { Data } from "effect";
import type { ResourceErrorData } from "./DomainError";

/**
 * General resource error
 */
export class ResourceError extends Data.TaggedError("@/ResourceError")<ResourceErrorData> {}

/**
 * Error thrown when a required resource is not found
 */
export class ResourceNotFoundError extends Data.TaggedError("@/ResourceNotFoundError")<
  ResourceErrorData & {
    readonly searchCriteria?: Record<string, unknown>;
  }
> {}

/**
 * Error thrown when resource access is denied
 */
export class ResourceAccessDeniedError extends Data.TaggedError("@/ResourceAccessDeniedError")<
  ResourceErrorData & {
    readonly requiredPermission: string;
    readonly userRole?: string;
  }
> {}

/**
 * Error thrown when resource is in use and cannot be modified
 */
export class ResourceInUseError extends Data.TaggedError("@/ResourceInUseError")<
  ResourceErrorData & {
    readonly usedBy: string[];
    readonly operation: string;
  }
> {}

/**
 * Error thrown when resource is locked
 */
export class ResourceLockedError extends Data.TaggedError("@/ResourceLockedError")<
  ResourceErrorData & {
    readonly lockedBy: string;
    readonly lockExpiry?: Date;
  }
> {}

/**
 * Error thrown when resource is in invalid state for operation
 */
export class ResourceStateError extends Data.TaggedError("@/ResourceStateError")<
  ResourceErrorData & {
    readonly currentState: string;
    readonly requiredState: string;
    readonly allowedStates: string[];
  }
> {}
